 <div class="row">
   <div class="col-lg-12">
     <app-table-title [fontSize]="'24px'"
                      [title]="(differentLoggedIn ? label : ('MY' | dictionary)) + ' ' + ('PORTFOLIO' | dictionary)"></app-table-title>

     <div class="m-portlet m-portlet--unair">
       <div class="m-portlet__body">
         <h3 class="text-color-light-text m-10-0" *ngIf="user">{{user.UserName}}</h3>
         <!--        NO data from BE -->
         <!--        <h5 class="text-color-light-text" *ngIf="user">{{user.Address}} -->
         <!--        </h5> -->
         <!--        <h5 class="text-color-light-text" *ngIf="user">{{user.Address2}} -->
         <!--        </h5> -->
         <hr>
         <div class="text-color-light-text d-flex contact-group" *ngIf="user"><span
           class="contact-label">{{'EMAIL' | dictionary}}:</span> <span class="text-color-black">{{user.Email}}</span>
         </div>
         <div class="text-color-light-text d-flex contact-group" *ngIf="user"><span
           class="contact-label">{{'PHONE' | dictionary}}:</span> <span class="text-color-black">{{user.Phone}}</span>
         </div>

         <div class="table-responsive" style="padding-top: 10px;">
           <app-investments-block
                                  [userInfo]="userInfo"></app-investments-block>
         </div>
       </div>
     </div>
   </div>
 </div>

 <app-pop-up-dialog [Message]="alertMessage" [Display]="display" (DisplayBack)="onConfirm()">
 </app-pop-up-dialog>
